export default __webpack_public_path__ + "static/media/ic_usdc.e_40.27f415ba.svg";